<template>
  <div class="c-search">
    <!-- <div class="c-search-row">
      <div class="c-search-by">
        <button class="active">Model</button>
        <button>Nadwozie</button>
      </div>
    </div> -->
    <h2>Model</h2>
    <div class="c-search-row">
      <div class="c-search-tab">
        <div class="c-search-model-list">
          <select v-model="modelSelectedKey">
            <option value="">Wybierz</option>
            <option  v-for="(ModelItem,key) in ModelList" v-bind:value="key">{{ModelItem.name}}</option>
          </select>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
export default {
  name: 'Search',
  props: [
    'ModelList'
  ],
  data: function(){
    return {
      modelSelectedKey: '',
    }
  },
  methods: {
    SelectModel (id){
      for(var key in this.ModelList){
        this.ModelList[key].selected = false
      }
      this.ModelList[id].selected = true

      this.$emit('ModelList', this.ModelList)
    }
  },
  watch: {
    modelSelectedKey: function(){
      this.SelectModel(this.modelSelectedKey);
    }
  }
}
</script>
<style lang="scss">
  .c-search{
    // margin: 0 auto;
    // max-width: 1177.6px;
    // width: 92%;
    // padding-bottom: 3rem;
    h2{
    @media(max-width:500px){
    font-size:17px;
    }
    }
    @media(min-width: 960px){
      padding-right: 2rem;
    }
    @media(min-width:500px){
    padding-right:1rem;
    }
    &-row{
          display: flex;
          // padding-bottom: 2rem;
          // border-bottom: 1px solid #b3b3b3;
    }
    &-engine{
      // h2{
      //   margin-top: 0rem;
      // }
    }
    &-model{
      &-list{
        // margin: 5rem 0;
        padding:0px;
        @media(max-width:500px){
        padding-right:5px;
        }
      }
      &-item{
        cursor: pointer;
        width: 25%;
        // min-height: 195px;
        float: left;
        @media(max-width: 1200px){
          width: 33.333%;
        }
        @media(max-width: 1000px){
          width: 50%;
          min-height: 135px;
        }
        &-title{
          margin-top: 1rem;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          strong{
            padding-left: 15px;
          }
        }
        img{
          // max-height: 125px;
          width: 88%;
        }
      }
    }
    &-by{
      display: flex;
      justify-content: center;
      vertical-align: middle;
      button{
        cursor: pointer;
        padding: 9px 20px;
        background-color: #fff;
        border: 1px solid #eceeef;
        background-color: #eceeef;
        &.active{
          background-color: #fff;
        }
        &:active{
          border: 1px solid #eceeef;
        }
      }
    }
    select{
      border: 1px solid #000;
      padding: .5rem 1rem;
      border-radius: 0;
      background-color: #fff;
      min-width: 180px;
      -webkit-appearance:none;
      @media(max-width:374px){
      min-width:150px;
      }
      option{
        color: #000;
      }
    }
  }
</style>
